"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SchemaContext = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _schemaReducer = _interopRequireDefault(require("./schema-reducer"));

var initialState = {
  title: "",
  description: "",
  type: "object",
  required: [],
  properties: {}
};

var Store = function Store(_ref) {
  var children = _ref.children,
      schema = _ref.schema;

  var _useReducer = (0, _react.useReducer)(_schemaReducer.default, schema || initialState),
      _useReducer2 = (0, _slicedToArray2.default)(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  return /*#__PURE__*/_react.default.createElement(SchemaContext.Provider, {
    value: [state, dispatch]
  }, children);
};

var SchemaContext = /*#__PURE__*/(0, _react.createContext)(initialState);
exports.SchemaContext = SchemaContext;
var _default = Store;
exports.default = _default;